export const quoteTypes = {
  ACTIVITY: 'activity',
  RELATIONSHIP: 'relationship',
};
